<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import { cart } from '../../models/cart.js'
  import { pages } from '../../models/pages.js'
  import { user } from '../../models/user.js'
  import CartMenu from '../../components/CartMenu.svelte'
  import UserMenu from '../../components/UserMenu.svelte'

  // Pull from DB when ready
  $: notifs = $pages.filter((p) => p.type === 'notification' && p.active)
  var dismissed = []

  var cartSize = null
  var openCart = cart.subscribe((value) => {
    // If item added to cart (but not when quantity of an item increases)
    if (value.length === cartSize + 1) {
      openMenu = 'cart'
      setTimeout(closeMenus, 2000)
    }

    cartSize = value.length
  })

  onMount(async () => {
    // logs user in if they have the cookies, doesnt do anything if not
    user.login()
    await cart.loadCart()

    // Load session cookie to see if user dismissed notifs
    let localNotifs = document.cookie
      .split('; ')
      .find((c) => c.startsWith('site-notifs'))

    if (localNotifs) {
      let cookieVal = localNotifs.split('=')[1]
      dismissed = JSON.parse(cookieVal)
    }

    storeNotifs()

    // close cart menu if user clicks around
    document.addEventListener('click', function (event) {
      const page = document.querySelector('main')
      if (page.contains(event.target) && openMenu === 'cart') {
        closeMenus()
      }
    })
  })

  var openMenu = null
  function toggleMenu(e) {
    var selMenu = e.target.dataset.menu
    openMenu = openMenu === selMenu ? null : selMenu
  }

  var openSubmenu = null
  function toggleSubmenu(e) {
    var selMenu = e.target.dataset.menu
    openSubmenu = openSubmenu === selMenu ? null : selMenu
  }

  function closeMenus() {
    openMenu = null
  }

  function closeSubmenus() {
    openSubmenu = null
  }

  function dismissNotif(id) {
    if (!dismissed.includes(id)) {
      dismissed.push(id)
      storeNotifs()
    }
  }

  function storeNotifs() {
    dismissed = dismissed
    document.cookie =
      'site-notifs=' + JSON.stringify(dismissed) + ';path=/;samesite=strict;'
  }
</script>

<style type="text/less">
  .header {
    background: var(--col-header-bg);
    border-bottom: solid 1px var(--col-gray-90);
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  .header-notif {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--col-accent-2);
    margin-bottom: 1px;
    padding: var(--spacing-xs) var(--spacing-sm);
    color: var(--col-bg);

    --col-link: var(--col-accent-1);
    --col-link-visited: var(--col-accent-1);
    --col-link-hover: var(--col-accent-1-l);
  }

  .header-cont {
    display: flex;
    max-width: var(--content-width);
    margin: auto;
  }

  .header-logo img {
    height: calc(var(--header-height) - 0.5rem);
    margin: 0.1rem 0 0.4rem;
  }

  .header-nav {
    position: relative;

    &:nth-child(3) {
      margin-left: auto;
    }
  }

  .nav-toggle {
    position: relative;
    background: var(--col-header-bg);
    border: none;
    color: var(--col-accent-2);
    padding: 0 var(--spacing-sm);
    min-width: var(--header-height);
    height: var(--header-height);
    cursor: pointer;
    z-index: 2;
    text-transform: uppercase;
    text-decoration: none;

    &:hover,
    &:focus {
      color: var(--col-accent-1);
    }

    .icon {
      font-size: 1.5rem;
      pointer-events: none;
    }

    .badge {
      font-size: 1.25rem;
      border: none;
      font-weight: bold;
      padding: 0;
      color: inherit;
      pointer-events: none;
    }
  }

  .nav-dropdown {
    pointer-events: none;
    position: absolute;
    top: var(--header-height);
    min-width: 200px;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.25s;
    background: var(--col-header-bg);
    box-shadow: 0 0 var(--shadow-size) var(--shadow-color);
    max-width: calc(100vw - var(--header-height));
  }

  .open > .nav-toggle {
    z-index: 12;
    color: var(--col-accent-1);
  }

  .open > .nav-dropdown,
  .open > .subnav {
    display: flex;
    flex-direction: column;
    z-index: 11;
    pointer-events: all;
    opacity: 1;
  }

  .nav-right > .nav-dropdown {
    right: 0;
  }

  .nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav-link {
    display: block;
    box-sizing: border-box;
    height: var(--line-height-xl);
    line-height: var(--line-height-xl);
    padding: 0 var(--spacing-sm);
    text-decoration: none;
    margin: 0;
    text-transform: uppercase;
  }

  .subnav {
    padding: 0;

    > li {
      display: block;
    }
  }

  /* Mobile Styles for submenus */
  @media (max-width: 900px) {
    .nav-dropdown {
      .nav-toggle {
        cursor: default;
        color: var(--col-text);
        box-shadow: none;
        font-weight: bold;
        height: var(--spacing-lg);
      }

      .subnav {
        border-bottom: solid 1px var(--col-gray-90);
      }
    }
  }

  @media (min-width: 900px) {
    /* On large enough screens, main menu is always visible */
    .main-nav > .nav-toggle {
      display: none;
    }
    .main-nav .nav-dropdown {
      display: block;
      box-shadow: none;
      background: transparent;
      position: static;
      opacity: 1;
      pointer-events: all;
    }

    .subnav {
      pointer-events: none;
      position: absolute;
      top: var(--header-height);
      min-width: 200px;
      z-index: 1;
      opacity: 0;
      transition: opacity 0.25s;
      background: var(--col-header-bg);
      box-shadow: 0 0 var(--shadow-size) var(--shadow-color);
      max-width: calc(100vw - var(--header-height));
    }

    .nav-link {
      height: var(--header-height);
      line-height: var(--header-height);
    }

    .main-nav .nav-list > li {
      display: inline-block;
    }
  }
</style>

<header class="header">
  {#each notifs as n}
    {#if !dismissed.includes(n.id)}
      <div class="header-notif">
        <p>
          {@html n.name}
          <a href={'/' + n.url_path}>
            Read More
            <svg class="icon">
              <use href="/icons.svg#keyboard_arrow_right" />
            </svg>
          </a>
        </p>
        <button
          class="btn"
          aria-label="Clear Notification"
          on:click={() => dismissNotif(n.id)}>
          <svg class="icon">
            <use href="/icons.svg#clear" />
          </svg>
        </button>
      </div>
    {/if}
  {/each}

  <div class="header-cont">
    <a class="header-logo nav-link" href="/">
      <img
        rel="preload"
        src="https://images.puzzleexchange.com/logo.svg"
        alt="Missing Piece Puzzle Exchange" />
    </a>

    <nav class="header-nav main-nav" class:open={openMenu === 'main'}>
      <button
        data-menu="main"
        aria-label="Open Navigation Menu"
        class="nav-toggle"
        on:click={toggleMenu}>
        <svg class="icon">
          <use href="/icons.svg#menu" />
        </svg>
      </button>
      <div class="nav-dropdown">
        <ul
          class="nav-list"
          on:click={closeMenus}
          on:mouseleave={closeSubmenus}>
          <li class="nav-subnav" class:open={openSubmenu === 'rent'}>
            <a
              class="nav-toggle"
              data-menu="rent"
              href="/rent"
              on:mouseenter={toggleSubmenu}>
              Rent & Return
            </a>
            <ul class="subnav">
              <li>
                <a class="nav-link" href="/ways-to-rent">Ways to Rent</a>
              </li>
              <li>
                <a class="nav-link" href="/rent">Puzzle Rentals</a>
              </li>
            </ul>
          </li>
          <li class="nav-subnav" class:open={openSubmenu === 'buy'}>
            <a
              class="nav-toggle"
              data-menu="buy"
              href="/shop"
              on:mouseenter={toggleSubmenu}>
              Buy & Keep
            </a>
            <ul class="subnav">
              <li>
                <a class="nav-link" href="/sale">Discounted</a>
              </li>
              <li>
                <a class="nav-link" href="/accessories">Accessories</a>
              </li>
              <li>
                <a class="nav-link" href="/shop">Puzzles</a>
              </li>
            </ul>
          </li>
          <li class="nav-subnav" class:open={openSubmenu === 'gift'}>
            <a
              class="nav-toggle"
              data-menu="gift"
              href="/gift"
              on:mouseenter={toggleSubmenu}>
              Gift
            </a>
            <ul class="subnav">
              <li>
                <a class="nav-link" href="/gift-cards">Gift Cards</a>
              </li>
              <li>
                <a class="nav-link" href="/gift">Memberships</a>
              </li>
              <li>
                <a class="nav-link" href="/redeem">Redeem</a>
              </li>
            </ul>
          </li>
          <li>
            <a class="nav-link" href="/events">Events</a>
          </li>
          <li>
            <a class="nav-link" href="/info/contact-us">Contact Us</a>
          </li>
          <li>
            <a class="nav-link" href="/info/about-us">About Us</a>
          </li>
        </ul>
      </div>
    </nav>

    <nav class="header-nav nav-right cart-nav" class:open={openMenu === 'cart'}>
      <button
        data-menu="cart"
        aria-label="Open Cart"
        class="nav-toggle"
        on:click={toggleMenu}>
        <svg class="icon">
          <use href="/icons.svg#cart" />
        </svg>
        <span class="badge">
          {$cart.reduce((a, c) => {
            return a + c.quantity
          }, 0)}
        </span>
      </button>
      <div class="nav-dropdown" on:click={closeMenus}>
        <CartMenu />
      </div>
    </nav>

    <nav class="header-nav nav-right user-nav" class:open={openMenu === 'user'}>
      <button
        data-menu="user"
        aria-label="Open Account Menu"
        class="nav-toggle"
        on:click={toggleMenu}>
        <svg class="icon">
          <use href="/icons.svg#person" />
        </svg>
      </button>
      <div class="nav-dropdown" on:click={closeMenus} transition:fade>
        <UserMenu />
      </div>
    </nav>
  </div>
</header>
